import { render, staticRenderFns } from "./AdminUserProfile.vue?vue&type=template&id=a8869cae&scoped=true&"
import script from "./AdminUserProfile.vue?vue&type=script&lang=ts&"
export * from "./AdminUserProfile.vue?vue&type=script&lang=ts&"
import style0 from "./AdminUserProfile.vue?vue&type=style&index=0&id=a8869cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8869cae",
  null
  
)

export default component.exports